import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0D0145', //  primary color    
      contrastText: '#fff',
    },
    secondary: {
      main: '#FF7A59', //  secondary color
      contrastText: '#fff',
    },
    text:{
        primary:'#373942',
        secondary:'#171717',
    },
    background:{
        default:'#F6F8FC'
    },
  //  accordionBorder: '#CFDFFC',  
  },
  shadows:[
    'none',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
    '0px 1px 5px 0px #CFDFFC',
  ],
  typography:{
    fontFamily: '"poppins", sans-serif',

    h1:{
        fontSize:'32px',
        fontWeight:600,
        lineHeight: 'normal',
    },
    h2:{
        fontSize:'24px',
        fontWeight:600,
        lineHeight: 'normal',
    },
    h3: {
        fontSize: "18px",
        fontWeight: 600,
        lineHeight: 'normal',
      },
      h4: {
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: 'normal',
      },
  }, 
  components: {
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
          '&.col-2':{
            '& .MuiListItemText-root':{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap:'8px',
              margin: '8px 0',
              '& .MuiListItemText-primary':{
                flex: 1,
                color: '#171717',
                fontWeight: 500,
                fontSize: 13,
              },
              '& .MuiListItemText-secondary':{
                flex: 2,
                color: '#373942',
                fontWeight: 400,
                fontSize: 13,
              },
            }
           
          }
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {         
          margin: '8px 0',
        },
        primary: {     
          color: '#171717',
          fontWeight: 500,
          fontSize: 14,
        },
        secondary: {     
          color: '#373942',
          fontWeight: 400,
          fontSize: 14,
        },
      },
    },
    MuiPopper:{
      styleOverrides:{
        root:{
          // boxShadow:'0px 1px 5px 0px #CFDFFC'
        }
      }
    },
  MuiFormLabel:{
    styleOverrides:{
      root:{
        '&.MuiInputLabel-shrink':{
          fontSize:14,
          fontWeight:600,
        }
      
      }
    }
  }
  },
});

export default theme;